export default __webpack_public_path__ + "static/img3-72aeea1ea37ab27318dbe110ba1f96ae.png";